import HttpClient from '@/common/lib/http-client'
import { IContactEntry, ContactEntry } from '@/common/models/data/dashboard/contact'

import { contact as Api } from '@/app/api'

class ContactRepository {
    async all (): Promise<Array<ContactEntry>> {
        const response = await HttpClient.getJson<Array<IContactEntry>>(Api.index)

        return response.map(entry => new ContactEntry(entry))
    }
}

export default new ContactRepository()
